// extracted by mini-css-extract-plugin
module.exports = {"VideoHome":"VideoHome_VideoHome__22_rs","Wrap":"VideoHome_Wrap__2ZKSz"};